// extracted by mini-css-extract-plugin
export var fullGrid = "_35-3";
export var pdpPreviewContainer = "_35-1";
export var previewContainer = "_35-0";
export var togglePreviewContainer = "_35-2";